import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  abortProcess,
  setIsProcessing,
} from 'state/bulkDeleteBusiness/actions';
import {
  Button,
  Grid,
  Message,
  Progress,
  Segment,
  Table,
} from 'semantic-ui-react';
import { Prompt } from 'react-router-dom';
import ProcessStatus from '../../constants/bulkAction/processStatus';

function ProcessingPage() {
  const dispatch = useDispatch();
  const {
    processed,
    businessIds,
    errors,
    currentBusinessId,
    status,
    cancelRequested,
  } = useSelector(state => state.bulkDeleteBusiness.process);
  const total = businessIds.length;
  const statusIs = checked => status === checked;

  const renderErrorMessages = messages => {
    if (isEmpty(messages)) {
      return <em>No Error Message</em>;
    }

    return messages.join(', ');
  };

  const onCancel = () => dispatch(abortProcess());

  const renderProgressMessage = () => {
    const percentage = (processed / total) * 100;
    const percentageStr = Math.floor(percentage * 100) / 100;
    switch (status) {
      case ProcessStatus.Completed:
        return 'All Completed Successfully';
      case ProcessStatus.CompletedWithWarning:
        return 'Completed with some errors';
      case ProcessStatus.AllFailed:
        return 'All Failed';
      case ProcessStatus.Aborted:
        return 'Process Aborted, current business has already been processed';
      case ProcessStatus.Error:
        return 'Error';
      default:
        return `Processing ${processed} of ${total} (${percentageStr}%)`;
    }
  };

  const isProcessing = useSelector(
    state => state.bulkDeleteBusiness.isProcessing
  );
  const globalError = useSelector(
    state => state.bulkDeleteBusiness.process.globalError
  );
  return (
    <>
      <Prompt
        when={isProcessing && statusIs(ProcessStatus.InProgress)}
        message="Are you sure you want to leave? The process is not yet completed"
      />
      {globalError && <Message error header="Error" content={globalError} />}
      <p>
        Now processing, this may take some time. Please do not close this page
        or navigate away
      </p>
      <Segment>
        <p>
          Processing Business ID: <strong>{currentBusinessId}</strong>
        </p>
        <Grid columns="equal">
          <Grid.Column>
            <Progress
              progress="ratio"
              value={processed}
              total={total}
              active={statusIs(ProcessStatus.InProgress)}
              warning={statusIs(ProcessStatus.CompletedWithWarning)}
              error={
                statusIs(ProcessStatus.AllFailed) ||
                statusIs(ProcessStatus.Error)
              }
              success={statusIs(ProcessStatus.Completed)}
              disabled={statusIs(ProcessStatus.Aborted)}
            >
              {renderProgressMessage()}
            </Progress>
          </Grid.Column>
          <Grid.Column width={2}>
            {statusIs(ProcessStatus.InProgress) && (
              <Button
                negative
                onClick={onCancel}
                title="Abort"
                disabled={cancelRequested}
              >
                {cancelRequested ? 'Stopping...' : 'Stop'}
              </Button>
            )}
            {!statusIs(ProcessStatus.InProgress) && (
              <Button primary onClick={() => dispatch(setIsProcessing(false))}>
                Reset
              </Button>
            )}
          </Grid.Column>
        </Grid>
      </Segment>
      {!isEmpty(errors) && (
        <>
          <h3>Errors</h3>
          <Table selectable celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Business ID</Table.HeaderCell>
                <Table.HeaderCell>Errors</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {errors.map(error => (
                <Table.Row key={error.businessId}>
                  <Table.Cell>{error.businessId}</Table.Cell>
                  <Table.Cell>{renderErrorMessages(error.messages)}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </>
      )}
    </>
  );
}

export default ProcessingPage;
